import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Document } from 'app/_models/document';
import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';

@Injectable()
export class DocumentService extends ApiService {
  constructor(private http: Http) {
    super('api/documents/', http);
  }

  getDocument(id: number): Observable<Document> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}${id}/`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  create(data): Observable<Document> {
    return this.http
      .post(this.apiUrl + this.endpointUrl, data, { headers: this.getHeaders(false) })
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(doc: Document): Observable<Document> {
    const url = `${this.apiUrl + this.endpointUrl}${doc.id}/`;

    return this.http.put(url, JSON.stringify(doc), { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  delete(id: number): Observable<void> {
    const url = `${this.apiUrl + this.endpointUrl}${id}/`;

    return this.http.delete(url, { headers: this.getHeaders() }).catch(this.handleError);
  }

  attachmentFile(document: Document, file: File): Observable<Document> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_id', String(document.id));

    const url = `${this.apiUrl + this.endpointUrl}${document.id}/upload_attachment_file`;
    return this.http
      .post(url, formData, { headers: this.getHeaders(false) })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/document.service.ts